import { Outlet } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { FavoritesProvider } from "@/hooks/useFavorites";

export default function SiteLayout() {
  return (
    <FavoritesProvider>
      <div className="flex min-h-screen flex-col bg-background-50">
        <SiteHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </FavoritesProvider>
  );
}